import React, { useEffect, useState, useContext } from "react";
import { message } from "antd";
import './Widgets.css'
import { useLayoutHeader } from "components/MainLayout";
import { getRideApi } from "api";
import { GeolocationContext } from "components/GeolocationContext";
import CurrentRideView from "./CurrentRideView";
import { connect } from "react-redux";
import { selectVehicleDetails } from "store/ride/reducer";
import { getVehicleDetails } from "store/ride/actions";
import { bindActionCreators } from "redux";


function roundToOne(num) {
    return +(Math.round(num + "e+1") + "e-1");
}

const headerConfig = {
    closeable: false,
    menuEnabled: true,
    customClass: 'fixed-header transparent',
}

function CurrentRide(props) {
    useLayoutHeader(headerConfig)
    const { finishRide, rideFinishing, currentRide, getVehicleDetails, vehicleDetails } = props;

    useEffect(() => {
        if (currentRide.vehicleId !== null && currentRide.vehicleId !== undefined) {
            getVehicleDetails(currentRide.vehicleId);
        }
        const interval = setInterval(() => {
            if (currentRide.vehicleId !== null && currentRide.vehicleId !== undefined) {
                getVehicleDetails(currentRide.vehicleId);
            }
        }, 3000);
        return () => clearInterval(interval);

    }, []);

    useEffect(() => {
        presentRideTime()
        const interval1 = setInterval(() => {
            presentRideTime()
        }, 1000);
        return () => clearInterval(interval1);
    }, []);

    useEffect(()=> {
        if(vehicleDetails?.availability && vehicleDetails.availability !== "INUSE") {
            console.warn('vehicle no longer in use, should finish the ride')
            finishRide()
        }
    }, [vehicleDetails])

    const { coords } = useContext(GeolocationContext)
    const speed = coords && coords.speed ? roundToOne(coords.speed * 3.6) : "۰"

    const [rideTime, setRideTime] = useState("00:00")
    const [requestedLights, setRequestedLights] = useState(undefined)
    const [requestedLock, setRequestedLock] = useState(undefined)
    const vlock = vehicleDetails?.lock
    const vLights = vehicleDetails?.setting?.headlight
    const lockLoading = requestedLock !== undefined ? (requestedLock !== vlock) : false
    const settingLoading = (vLights !== undefined && requestedLights !== undefined) ? requestedLights !== vLights : false

    useEffect(() => {
        if (requestedLights === undefined) {
            if (!lockLoading && !settingLoading) {
                setRequestedLights(vLights)
            }
        }
    }, [requestedLights, vLights, lockLoading, settingLoading]);

    useEffect(() => {
        if (requestedLock === undefined) {
            if (vlock !== undefined) {
                setRequestedLock(vlock)
            }
        }
    }, [vlock, requestedLock]);

    const onLock = (e) => {
        getRideApi().rideLock()
            .then((resp) => {
            })
            .catch((error) => {
                message.error("خطا در بازکردن دستگاه!!!")
            });
    }

    const onUnlock = (e) => {
        getRideApi().rideUnlock()
            .then((resp) => {
            })
            .catch((error) => {
                message.error("خطا در قفل کردن دستگاه!!!")
            });
    }

    const lockChange = () => {
        setRequestedLock(!vlock)
        if (vlock) {
            onUnlock()
        } else {
            onLock()
        }
        setRequestedLights(undefined)
    }
    const changeLights = () => {
        setRequestedLights(!vLights)

        let rideSettingRequest = {
            scooterSetting: {
                headlight: !vLights,
                speedMode: null,
                throttle: null,
                taillights: !vLights
            }
        }
        getRideApi().rideSetting(rideSettingRequest)
            .then((_) => message.info("دستور ارسال شد."))
            .catch((reason) => {
                message.error("خطا در تغییر وضعیت چراغ‌ها!");
            });
    }
    const playBeep = () => {
        getRideApi().rideBeep()
            .then((_) => message.info("دستور ارسال شد."))
            .catch((reason) => {
                message.error("خطا در بوق زدن!");
            });

    }

    function presentRideTime() {
        const nowTime = Date.now();
        const rideTimeMiliSeconds = nowTime - currentRide.startTime.getTime();
        const rideTimeSeconds = rideTimeMiliSeconds / 1000;
        const h = Math.floor(rideTimeSeconds / 3600);
        const m = Math.floor(rideTimeSeconds % 3600 / 60);
        const s = Math.floor(rideTimeSeconds % 3600 % 60);
        setRideTime(h + ":" + m + ":" + s);
    }

    const vehiclesPos = (vehicleDetails !== undefined && vehicleDetails.location) ? [[vehicleDetails.location.lat, vehicleDetails.location.lon]] : [];

    return <CurrentRideView
        finishRide={finishRide}
        rideFinishing={rideFinishing}
        changeLights={changeLights}
        lockChange={lockChange}
        lockLoading={lockLoading}
        playBeep={playBeep}
        rideTime={rideTime}
        settingLoading={settingLoading}
        speed={speed}
        vehicleDetails={vehicleDetails}
        vehicleLightsOn={vLights}
        vehicleLock={vlock}
        vehiclesPos={vehiclesPos}
    />
}

const mapStateToProps = (state) => ({
    vehicleDetails: selectVehicleDetails(state),
})

const mapDispatchToProps = (dispatch) => bindActionCreators(
    {
        getVehicleDetails,
    },
    dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(CurrentRide)
